module.exports = __webpack_public_path__ + "media/images/riders/small/GUNN-RITA_DAHLE_FLESJA-4eba04835bfd3e6014cbcbb85f188e82.png";